/**
 * Glossary Panel (Phase 2 — Step 2.16).
 *
 * Searchable glossary of domain terms.
 */

import React, { useState, useMemo } from 'react';
import { GLOSSARY_DATA } from '@/data/glossary';

export function GlossaryPanel(): React.ReactElement {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    if (!search.trim()) return GLOSSARY_DATA;
    const q = search.toLowerCase();
    return GLOSSARY_DATA.filter(
      (g) =>
        g.term.toLowerCase().includes(q) ||
        g.definition.toLowerCase().includes(q),
    );
  }, [search]);

  return (
    <div className="glossary-panel" role="region" aria-label="Glossary">
      <h3>Glossary</h3>

      <input
        type="search"
        className="glossary-panel__search"
        placeholder="Search terms..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        aria-label="Search glossary"
      />

      <dl className="glossary-panel__list">
        {filtered.map((entry) => (
          <div key={entry.term} className="glossary-panel__entry">
            <dt>{entry.term}</dt>
            <dd>{entry.definition}</dd>
          </div>
        ))}
      </dl>

      {filtered.length === 0 && (
        <p className="glossary-panel__empty">No matching terms found.</p>
      )}
    </div>
  );
}
